import moment from 'moment';

export const getWeekdaysCount = (startDate, endDate) => {
    // Parse the input dates using Moment.js
    const startMoment = moment(startDate);
    const endMoment = moment(endDate);
    // Initialize count of weekdays
    let weekdaysCount = 0;

    // Loop through each day in the range
    while (startMoment.isSameOrBefore(endMoment, 'day')) {
        // Check if the current day is not a weekend (Saturday or Sunday)
        if (startMoment.day() !== 0 && startMoment.day() !== 6) {
            weekdaysCount++;
        }
        // Move to the next day
        startMoment.add(1, 'day');
    }

    return weekdaysCount;
};

export const getWeekdaysCountForMonth = (startDate, endDate, month) => {
    // Parse the input dates using Moment.js
    const startMoment = moment(startDate);
    const endMoment = moment(endDate);
    // Initialize count of weekdays
    let weekdaysCount = 0;

    // Loop through each day in the range
    while (startMoment.isSameOrBefore(endMoment, 'day')) {
        // // Check if the current day is not a weekend (Saturday or Sunday)
        // if (startMoment.day() === 0 || startMoment.day() === 6) {
        //     // continue;
        // } else if (startMoment.month() === moment(month, 'MMMM').month()) {
        //     weekdaysCount++;
        // }
        if (startMoment.day() !== 0 && startMoment.day() !== 6) weekdaysCount++;
        // Move to the next day
        startMoment.add(1, 'day');
    }
    return weekdaysCount;
};

export const getTotalDaysInMonth = ({
    demandStartDate,
    demandEndDate,
    year,
    month
}) => {
    const numericMonth = moment(month, 'MMMM');
    const demandStartMonth = moment(demandStartDate).month();
    const demandEndMonth = moment(demandEndDate).month();

    const isDemandStartMonth = demandStartMonth === numericMonth.month();
    const isDemandEndMonth = demandEndMonth === numericMonth.month();

    const firstDayOfMonth = isDemandStartMonth
        ? moment(moment(demandStartDate).format('YYYY-MM-DD'), 'YYYY-MM-DD')
        : moment(`${year}-${numericMonth.format('MM')}-01`, 'YYYY-MM-DD');
    const lastDayOfMonth = isDemandEndMonth
        ? moment(moment(demandEndDate).format('YYYY-MM-DD'), 'YYYY-MM-DD')
        : firstDayOfMonth.clone().endOf('month');

    const totalWorkingDaysForMonth = getWeekdaysCount(firstDayOfMonth.toDate(), lastDayOfMonth.toDate());
    return totalWorkingDaysForMonth;
};

export const getMonths = (startDate, endDate) => {
    const startMoment = moment(startDate);
    const endMoment = moment(endDate);

    const months = [];
    while (startMoment.isSameOrBefore(endMoment, 'month')) {
        months.push({
            month: startMoment.format('MMMM'),
            year: startMoment.format('YYYY')
        });
        startMoment.add(1, 'month').startOf('month');
    }

    return months;
};

export const calculateTotalHrsForMonths = (months, hrsPerDay, demandStartDate, demandEndDate) => months?.map((month) => {
    const numericMonth = moment(month.month, 'MMMM');
    const demandStartMonth = moment(demandStartDate).month();
    const demandEndMonth = moment(demandEndDate).month();

    const isDemandStartMonth = demandStartMonth === numericMonth.month();
    const isDemandEndMonth = demandEndMonth === numericMonth.month();

    const firstDayOfMonth = isDemandStartMonth
        ? moment(moment(demandStartDate).format('YYYY-MM-DD'), 'YYYY-MM-DD')
        : moment(`${month.year}-${numericMonth.format('MM')}-01`, 'YYYY-MM-DD');
    const lastDayOfMonth = isDemandEndMonth
        ? moment(moment(demandEndDate).format('YYYY-MM-DD'), 'YYYY-MM-DD')
        : firstDayOfMonth.clone().endOf('month');

    const totalWorkingDaysForMonth = getWeekdaysCount(firstDayOfMonth.toDate(), lastDayOfMonth.toDate());
    return {
        ...month,
        hours: Math.round(hrsPerDay * totalWorkingDaysForMonth)
    };
});

export const isChangeInTimeline = (oldTimeline, currentTimeline) => {
    const currentyear = `${moment().year()}`;

    const oldTimelineMap = oldTimeline.reduce((acc, el) => {
        const year = `${el.year}`.length === 2 ? `${currentyear.slice(0, 2)}${el.year}` : `${el.year}`;
        const month = moment().month(el.month).format('MMMM');
        acc[`${month}-${year}`] = el.totalHours ?? el.hoursPerMonth ?? el.hours;
        Object.assign(el, { year, month });
        el.hours = el.totalHours ?? el.hoursPerMonth ?? el.hours;

        return acc;
    }, {});
    let isChanged = false;

    (oldTimeline.length > currentTimeline.length ? oldTimeline : currentTimeline).forEach((el) => {
        if (oldTimelineMap[`${el.month}-${el.year}`] != el?.hours && typeof el?.hours == 'number') {
            isChanged = true;
        }
    });

    return isChanged;
};

export const getTimelinePayload = (timelines) => {
    const data = timelines.reduce((acc, timeline) => {
        if(!acc[timeline.year]){
            acc[timeline.year] = {
                year: timeline.year
            };
        }
        if(!acc[timeline.year][timeline.month]){
            acc[timeline.year][timeline.month] = timeline?.updatedHours ? timeline?.updatedHours : timeline?.hours;
            if(!acc[timeline.year].monthWeeksData) {
                acc[timeline.year].monthWeeksData = {};
            }
            acc[timeline.year].monthWeeksData[timeline.month] = timeline.weeksData;
            if(!acc[timeline.year].originalVale) {
                acc[timeline.year].originalVale = {};
            }
            acc[timeline.year].originalVale[timeline.month] = timeLine?.updatedHours ? timeLine?.hours : null;
        }

        return acc;
    }, {});

    console.log('ss', data)

    return Object(data).values()
}
